export const PRIORITY = {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH',
    CRITICAL: 'CRITICAL',
};
/**
 * Least to most urgent.
 *
 * Written down because a support tier can set a floor — "nothing from this product is filed below
 * HIGH" — and comparing two priorities needs an order that is stated once rather than inferred
 * from the declaration order of an object, which is not a promise anybody should rely on.
 */
export const PRIORITY_ORDER = [
    PRIORITY.LOW,
    PRIORITY.MEDIUM,
    PRIORITY.HIGH,
    PRIORITY.CRITICAL,
];
/** True when `candidate` is at least as urgent as `floor`. */
export function isAtLeastAsUrgent(candidate, floor) {
    return PRIORITY_ORDER.indexOf(candidate) >= PRIORITY_ORDER.indexOf(floor);
}
export const PRIORITY_LABELS = {
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
    CRITICAL: 'Critical',
};
//# sourceMappingURL=priority.js.map